import {NodeTypes} from '../../../constants/nodeTypes';

/**
 * Convert a JSON circuit object into a react-d3-tree node tree.
 */
export const convertCircuitToTree = (circuit, count) => {
  let treeObj = {};
  treeObj.name = count;
  treeObj.type = NodeTypes.CIRCUIT;
  const {circuits, evChargers, ...attributes} = circuit;
  treeObj.attributes = attributes;

  treeObj.children = [];
  let index = 0;

  if (circuits?.length > 0) {
    for (let i = 0; i < circuits.length; i++) {
      treeObj.children.push(convertCircuitToTree(circuits[i], `${count},${index}`));
      index++;
    }
  }

  if (evChargers?.length > 0) {
    for (let i = 0; i < evChargers.length; i++) {
      treeObj.children.push({
        name: `${count},${index}`,
        type: NodeTypes.EVCHARGER,
        attributes: evChargers[i],
      });
      index++;
    }
  }

  // Add node placeholder at the end
  treeObj.children.push({
    name: `${count},${index}`,
    type: NodeTypes.ADDNODE,
  });

  return treeObj;
};

/**
 * Convert a react-d3-tree node tree back into a JSON circuit object.
 */
export const convertTreeToCircuit = (treeObj) => {
  const {type, attributes, children} = treeObj;
  let obj = {};

  if (type === NodeTypes.CIRCUIT) {
    obj = {
      ...attributes,
      circuits: [],
      evChargers: [],
    };
    if (children?.length > 0) {
      for (let i = 0; i < children.length; i++) {
        if (children[i].type === NodeTypes.CIRCUIT) {
          const convertedCircuit = convertTreeToCircuit(children[i]);
          if (Object.keys(convertedCircuit).length > 0) {
            obj.circuits.push(convertedCircuit);
          }
        } else if (children[i].type === NodeTypes.EVCHARGER) {
          obj.evChargers.push(children[i].attributes);
        }
      }
    }
    if (obj.circuits.length === 0) delete obj.circuits;
    if (obj.evChargers.length === 0) delete obj.evChargers;
  } else if (type === NodeTypes.EVCHARGER) {
    obj = {...attributes};
  }

  return obj;
};

/**
 * Recursively walk the tree and update the first node matching conditionFn.
 */
export const updateNestedObject = (obj, conditionFn, updateFn, newChild = null, parent = null) => {
  if (conditionFn(obj)) {
    let nodeTypeBefore = obj.type;
    updateFn(obj);
    if (parent && newChild && nodeTypeBefore === NodeTypes.ADDNODE) {
      parent.push(newChild);
    }
    return true;
  }
  if (typeof obj === 'object' && obj !== null) {
    for (const key in obj) {
      if (obj[key] && typeof obj[key] === 'object') {
        if (updateNestedObject(obj[key], conditionFn, updateFn, newChild, obj)) {
          return true;
        }
      }
    }
  }
  return false;
};

